import { all, fork } from "redux-saga/effects";
import appConfigSaga from "./appConfig";
import otpSaga from "./otp";
import applicationInfo from "./applicantInfoForm";
import sendProspectToAPI from "./sendProspectToAPI";
import stakeholders from "./stakeholders";
import retrieveUploadDoc from "./uploadDocuments";
import searchProspectSaga from "./searchProspect";
import retrieveApplicantInfo from "./retrieveApplicantInfo";
import loginForm from "./loginForm";
import sendAecbFtsEmail from "./sendAecbFtsEmail";
import getSignatoryInfo from "./getSignatoryInfo";
import agentFeatures from "./agentFeatures";
import sendAdhocEmailSagas from "./sendAdhocEmail";
import dropOffAuthorizeSagas from "./dropOffAuthorize";

export default function*() {
  yield all([
    fork(appConfigSaga),
    fork(loginForm),
    fork(otpSaga),
    fork(applicationInfo),
    fork(sendProspectToAPI),
    fork(stakeholders),
    fork(searchProspectSaga),
    fork(retrieveApplicantInfo),
    fork(retrieveUploadDoc),
    fork(sendAecbFtsEmail),
    fork(getSignatoryInfo),
    fork(agentFeatures),
    fork(sendAdhocEmailSagas),
    fork(dropOffAuthorizeSagas)
  ]);
}
